import { render, staticRenderFns } from "./setUserConfigurationSalesNavigator.vue?vue&type=template&id=5bf9fac6&scoped=true&"
import script from "./setUserConfigurationSalesNavigator.vue?vue&type=script&lang=js&"
export * from "./setUserConfigurationSalesNavigator.vue?vue&type=script&lang=js&"
import style0 from "./setUserConfigurationSalesNavigator.vue?vue&type=style&index=0&id=5bf9fac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9fac6",
  null
  
)

export default component.exports